'use strict';
var FaqBlock = /** @class */ (function () {
    function FaqBlock(element) {
        this.faqBlock = element;
        this.faqItems = Array.from(this.faqBlock.querySelectorAll('.faq-block-item'));
        this.addEventListeners();
    }
    FaqBlock.prototype.addEventListeners = function () {
        var _this = this;
        this.faqItems.forEach(function (faqItem) {
            var faqItemHeader = faqItem.querySelector('.faq-block-item-header');
            faqItemHeader.addEventListener('click', _this.toggleFaqItem.bind(_this));
        });
    };
    FaqBlock.prototype.toggleFaqItem = function (event) {
        var target = event.currentTarget;
        var faqItem = target.parentElement;
        var faqContentIsOpen = faqItem.classList.contains('active');
        if (faqContentIsOpen) {
            faqItem.classList.remove('active');
        }
        else {
            faqItem.classList.add('active');
        }
    };
    return FaqBlock;
}());
var faqBlocks = document.querySelectorAll('[data-faq-block]');
faqBlocks.forEach(function (faqBlock) {
    new FaqBlock(faqBlock);
});
